export class UnauthorizedError extends Error {
    constructor() {
        super("You must be authenticated to access to this resource.");
    }
}
